export class SignIn {
  static readonly type = '[Auth] SignIn';

  // these are parameters to pass to the action when dispatching it also known as metadata // they work just like normal parameters in normal parameters
  constructor(public keycloakId: string, public token: string) {}
}
